import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";

const DashboardService = {};

DashboardService.getDashboardCount = function (params) {
  return fetch({
    url: ApiConstant.DASHBOARD_COUNT,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
DashboardService.getSchoolDashboard = function (params) {
  return fetch({
    url: ApiConstant.DASHBOARD_SCHOOL_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
DashboardService.getOrderDashboard = function (params) {
  return fetch({
    url: ApiConstant.DASHBOARD_ORDER_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
DashboardService.getCompletedOrderDashboard = function (params) {
  return fetch({
    url: ApiConstant.DASHBOARD_COMPLETED_OERDER_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
DashboardService.getPendingOrderDashboard = function (params) {
  return fetch({
    url: ApiConstant.DASHBOARD_PENDING_ORDER_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
DashboardService.getCancelledOrderDashboard = function (params) {
  return fetch({
    url: ApiConstant.DASHBOARD_CANCELLED_ORDER_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
DashboardService.getStudentDashboard = function (params) {
  return fetch({
    url: ApiConstant.DASHBOARD_STUDENT_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
DashboardService.getRevenueDashboard = function (params) {
  return fetch({
    url: ApiConstant.DASHBOARD_REVENUE_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
export default DashboardService;
